import { useState } from "react";

const AccordionItem = ({ panel, question, answer, isExpanded, onToggle }) => (
  <div className="mb-3">
    <button
      onClick={() => onToggle(panel)}
      className="w-full bg-[#D6E4F5] hover:bg-[#C5D9EF] transition-colors rounded-lg px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between text-left"
    >
      <span className="text-[#29265b] font-bold text-sm sm:text-base md:text-lg pr-4">
        {question}
      </span>
      <svg
        className={`w-5 h-5 sm:w-6 sm:h-6 text-[#29265b] flex-shrink-0 transition-transform duration-300 ${
          isExpanded ? "rotate-180" : ""
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    {isExpanded && (
      <div className="bg-white px-4 sm:px-6 py-3 sm:py-4 rounded-b-lg border-l-4 border-[#1e72b9] mt-1">
        <div className="text-[#29265b] text-sm sm:text-base md:text-lg">
          {answer}
        </div>
      </div>
    )}
  </div>
);

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = useState("panel1");

  const handleChange = (panel) => {
    setExpanded(expanded === panel ? false : panel);
  };

  return (
    <>
      <section
        id="accordion-flush"
        className="flex justify-center mt-8 sm:mt-12 md:mt-20 px-4 sm:px-6"
      >
        <div className="w-full max-w-[1200px]">
          <div className="mx-auto max-w-[900px] text-center mb-8 sm:mb-10 md:mb-14">
            <p className="text-[#1e72b9] text-lg sm:text-xl md:text-2xl font-semibold mb-2 sm:mb-3">
              ¿Tienes dudas? Aquí tienes las respuestas
            </p>
            <h2 className="text-[#29265b] font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
              Preguntas frecuentes
            </h2>
          </div>

          <div className="max-w-[900px] mx-auto">
            <AccordionItem
              panel="panel1"
              isExpanded={expanded === "panel1"}
              onToggle={handleChange}
              question="¿En que se basa el modelo de negocios?"
              answer={
                <div>
                  <p className="mb-3">
                    Nuestro modelo de negocios se basa en la generación de
                    contactos de poder dentro de las grandes industrias, sumado
                    a herramientas de mercadotecnia y relaciones.
                  </p>
                  <p className="mb-3">
                    Realizamos diversas reuniones estratégicas en donde puedes
                    compartir experiencias con distintos empresarios.
                  </p>
                  <p>
                    Nuestro objetivo, es que tu obtengas resultados tangibles de
                    tu suscripción, es decir, ventas.
                  </p>
                </div>
              }
            />

            <AccordionItem
              panel="panel2"
              isExpanded={expanded === "panel2"}
              onToggle={handleChange}
              question="¿Cuanto tiempo llevan Industrial business Clusters en el mercado?"
              answer={
                <p>
                  En 2025 cumplimos 3 años de desarrollar conexiones de negocios
                  entre proveedores y grandes empresas.
                </p>
              }
            />

            <AccordionItem
              panel="panel3"
              isExpanded={expanded === "panel3"}
              onToggle={handleChange}
              question="¿Ser Socio tiene algún costo?"
              answer={
                <p>
                  Si, tenemos planes diseñados para diferentes tipos de
                  negocios, ya sea que seas proveedor de productos o servicios y
                  también el nivel de negocios que quieres desarrollar y la
                  exposición de tu marca.
                </p>
              }
            />

            <AccordionItem
              panel="panel4"
              isExpanded={expanded === "panel4"}
              onToggle={handleChange}
              question="¿Ustedes son Networking?"
              answer={
                <p>
                  No, no somos networking, somos una plataforma de negocios en
                  donde conectamos a grandes empresas con proveedores.
                </p>
              }
            />

            <AccordionItem
              panel="panel5"
              isExpanded={expanded === "panel5"}
              onToggle={handleChange}
              question="¿Que finalidad tienen las reuniones estratégicas de negocios?"
              answer={
                <p>
                  Estas reuniones tienen como finalidad que tu conozcas de
                  primera mano las necesidades de las Grandes empresas, además,
                  de poder generar relaciones industriales con los asistentes.
                </p>
              }
            />

            <AccordionItem
              panel="panel6"
              isExpanded={expanded === "panel6"}
              onToggle={handleChange}
              question="¿Es necesario estar presente en todas las reuniones?"
              answer={
                <p>
                  No, nuestro principal objetivo es generarte conexiones de
                  negocios, las reuniones sirven para poder compartir
                  experiencias, pero no es mandatorio la asistencia. Adicional,
                  la suscripción es por empresa, no por persona, entonces a
                  estas reuniones puede asistir alguien de tu equipo.
                </p>
              }
            />

            <AccordionItem
              panel="panel7"
              isExpanded={expanded === "panel7"}
              onToggle={handleChange}
              question="¿Si mi empresa esta altamente especializada en un sector industrial, ustedes me pueden ayudar a conectar con clientes de este rubro?"
              answer={
                <p>
                  Si, Ya que ingresas a IBC, nosotros tenemos una entrevista
                  contigo, en la cual entendemos tu negocio y perfilamos los
                  contactos potenciales a los cuales quieres llegar.
                </p>
              }
            />

            <AccordionItem
              panel="panel8"
              isExpanded={expanded === "panel8"}
              onToggle={handleChange}
              question="¿Ya tuve una experiencia con una empresa que también me generaba contactos de venta, cual es la diferencia que ustedes ofrecen con otras opciones?"
              answer={
                <p>
                  Nosotros a diferencia de otras opciones de mercado perfilamos
                  el contacto, es decir estudiamos el negocio con el cual te
                  vamos a conectar, para que tu tengas claridad y certeza del
                  tipo de conexión que vas a realizar. No solo compartimos un
                  mail o un teléfono de contacto. Adicional, nosotros te
                  ayudamos con la coordinación de la reunión ya sea virtual o
                  digital.
                </p>
              }
            />
          </div>

          {/*-------------------- Inicio sección de únete --------------------*/}
          <div className="mt-12 sm:mt-16 md:mt-20 text-center px-4">
            <div className="flex justify-center mb-6 sm:mb-8">
              <button
                onClick={() => (window.location.href = "/registrate")}
                className="bg-[#39a8e0] hover:bg-[#0092ff] text-white font-bold py-3 sm:py-4 px-8 sm:px-12 rounded-full text-base sm:text-lg md:text-xl transition-colors"
              >
                Quiero ser parte de IBC
              </button>
            </div>

            <h2 className="text-[#29265b] font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4 sm:mb-6">
              ¡Únete a nuestra red y eleva tu potencial de negocios!
            </h2>

            <p className="text-[#29265b] text-base sm:text-lg md:text-xl max-w-4xl mx-auto mb-10 sm:mb-12 md:mb-16 px-4">
              Conectamos visiones empresariales, para forjar enlaces
              estratégicos con grandes industrias. Juntos construimos puentes de
              oportunidades que fomentan el crecimiento mutuo.
            </p>

            <div className="mb-8 sm:mb-10">
              <h3 className="text-[#29265b] font-bold text-xl sm:text-2xl md:text-3xl mb-4 sm:mb-6">
                Síguenos en redes
              </h3>
              <p className="text-[#29265b] text-base sm:text-lg md:text-xl mb-6 sm:mb-8">
                Sé parte de una comunidad que conecta y expande negocios.
              </p>

              <div className="flex justify-center flex-wrap gap-3 sm:gap-4 md:gap-6">
                <a
                  href="https://www.facebook.com/share/1B9a1pXeXt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#39a8e0] hover:bg-[#1e72b9] transition-colors rounded-xl w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center"
                >
                  <svg
                    className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>

                <a
                  href="https://www.instagram.com/industrial_business_clusters?igsh=MWRjN2VlaHp4M3p0Mw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#39a8e0] hover:bg-[#1e72b9] transition-colors rounded-xl w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center"
                >
                  <svg
                    className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>

                <a
                  href="https://www.youtube.com/@Industrial_bunsiness_Clusters"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#39a8e0] hover:bg-[#1e72b9] transition-colors rounded-xl w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center"
                >
                  <svg
                    className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>

                <a
                  href="https://www.tiktok.com/@ibclusters?_t=ZS-8wBflqnmJ5r&_r=1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#39a8e0] hover:bg-[#1e72b9] transition-colors rounded-xl w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center"
                >
                  <svg
                    className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                  </svg>
                </a>

                <a
                  href="https://www.linkedin.com/company/industrial-business-clusters/?viewAsMember=true"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#39a8e0] hover:bg-[#1e72b9] transition-colors rounded-xl w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center"
                >
                  <svg
                    className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          {/*-------------------- Fin sección de únete --------------------*/}
        </div>
      </section>
    </>
  );
}
